// The live layer's context: what each app's ChatSocketProvider provides and
// `useChat` reads. The context object lives apart from the provider so React
// Fast Refresh can hot-reload the provider component cleanly.

import { createContext } from 'react';
import type { ChatStatus, CommsMessage, IPendingAttachment, MessageSegment } from '../../interfaces/ICommsApi.js';

export interface IChatContextValue {
  siteId: string; // Site this socket is scoped to — useChat reads it to fetch history.
  status: ChatStatus; // Connection status, shared by every channel using this socket.
  liveMessagesByChannel: Record<string, CommsMessage[] | undefined>; // Per-channel live message buckets. Read-only from consumers
  send: (channelId: string, segments: MessageSegment[], attachments: IPendingAttachment[]) => void;
  /** Files of messages the server hasn't confirmed, by clientMessageId — what a sending or failed row shows. */
  localAttachments: Record<string, IPendingAttachment[] | undefined>;
  retry: (message: CommsMessage) => void;
  discard: (message: CommsMessage) => void;
  reportRead: (channelId: string, messageIds: string[]) => void;
}

export const ChatContext = createContext<IChatContextValue | null>(null);
